import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const POST_ROUTE_DELIVERY_POINT_RESET = 'POST_ROUTE_DELIVERY_POINT_RESET';
export const POST_ROUTE_DELIVERY_POINT_LOADING = 'POST_ROUTE_DELIVERY_POINT_LOADING';
export const POST_ROUTE_DELIVERY_POINT_SUCCESS = 'POST_ROUTE_DELIVERY_POINT_SUCCESS';
export const POST_ROUTE_DELIVERY_POINT_REJECT = 'POST_ROUTE_DELIVERY_POINT_REJECT';

//* ACTIONS ------------------------------------------------
export const postRouteDeliveryPointReset = () => ({ type: POST_ROUTE_DELIVERY_POINT_RESET });
export const postRouteDeliveryPointLoading = () => ({ type: POST_ROUTE_DELIVERY_POINT_LOADING });
export const postRouteDeliveryPointSuccess = (payload) => ({ type: POST_ROUTE_DELIVERY_POINT_SUCCESS, payload });
export const postRouteDeliveryPointReject = (payload) => ({ type: POST_ROUTE_DELIVERY_POINT_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const postRouteDeliveryPointRequest = async (data, getState) => {
    const options = await withToken({
        method: Methods.PUT,
        data,
    }, getState);
    return request(`/Route/web/UpdateRouteDeliveryPoints`, options);
};
